import { BodyRegular, H3 } from '@components/atoms/typography';
import Button from '@components/atoms/button';

type TransfersMessageAction = {
  label: string;
  onClick: () => void;
  variant?: 'primary' | 'secondary' | 'tertiary';
};

type TransfersMessageProps = {
  title: string;
  description: string;
  action?: TransfersMessageAction;
  dataCy?: string;
};

export const TransfersMessage = ({
  title,
  description,
  action,
  dataCy
}: TransfersMessageProps) => (
  <div
    className="flex flex-col items-start gap-4 px-1 py-2"
    data-cy={dataCy ?? 'transfers-message'}
  >
    <div className="flex flex-col gap-1.5">
      <H3 className="mb-0">{title}</H3>
      <BodyRegular className="mb-0 text-neutral-600">{description}</BodyRegular>
    </div>
    {action && (
      <Button variant={action.variant ?? 'tertiary'} onClick={action.onClick}>
        {action.label}
      </Button>
    )}
  </div>
);
